import { usePermissions } from './PermissionContext';
import { MENU_MODULE_MAP } from './menuModuleMap';

/**
 * Standard module permission flags for list/detail screens.
 * @param {string} moduleOrMenuId - e.g. 'ORDERS' or 'Orders'
 */
export function useModuleAccess(moduleOrMenuId) {
  const { can, ownerAdmin, accessRestricted, loading } = usePermissions();
  const moduleKey = MENU_MODULE_MAP[moduleOrMenuId] || moduleOrMenuId;

  const canView = ownerAdmin || can(moduleKey, 'VIEW');
  const canCreate = ownerAdmin || can(moduleKey, 'CREATE');
  const canEdit = ownerAdmin || can(moduleKey, 'EDIT');
  const isReadOnly = canView && !canCreate && !canEdit;
  const canMutate = canCreate || canEdit;

  return {
    moduleKey,
    canView,
    canCreate,
    canEdit,
    isReadOnly,
    canMutate,
    ownerAdmin,
    accessRestricted,
    loading,
  };
}
